import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async';
import App from './App'
import './index.css'
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { LanguageProvider } from '@/lib/i18n';
import { ToastProvider } from '@/components/ui/Toast';


import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://71220fe75fdc7cec61e52e2105365f71@o4511423961825280.ingest.de.sentry.io/4511423977881680",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/tipsnorge\.no/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Catch unhandled promise rejections to prevent silent background crashes
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    Sentry.captureException(event.reason);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <LanguageProvider>
        <HelmetProvider>
            <ToastProvider>
                <App />
            </ToastProvider>
        </HelmetProvider>
    </LanguageProvider>,
)

